import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function PricingPage() {
  return <>
      <Helmet data-id="element-238">
        <title data-id="element-239">Pricing - Fifth Door</title>
        <meta name="description" content="Fifth Door Pricing." data-id="element-240" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-241" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-242" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-243" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-244">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-245" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-246" />

        <div className="absolute top-8 left-8 z-20" data-id="element-247">
          <Link to="/" className="flex items-center gap-3" data-id="element-248">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-249" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-250">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-251">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-252">
            PRICING
          </h1>
          <div className="text-white/70 leading-relaxed text-lg text-center" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-253">
            <p className="text-xl md:text-2xl text-white/80" data-id="element-254">
              Fifth Door is currently{' '}
              <span className="text-white font-semibold" data-id="element-255">free</span> for all
              users.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-256" />
    </>;
}